<app-main-menu title="Tags"></app-main-menu>

<div class="content mat-elevation-z8">
  <h1>Alle Tags</h1>

  <mat-list>
    <mat-list-item *ngFor="let tag of tags" class="tag-list-item">
      <span matListItemTitle>
        <mat-form-field>
          <mat-label>Bezeichnung</mat-label>
          <input matInput placeholder="Style" [value]="tag.designation" (change)="changeTag(tag, $event)">
        </mat-form-field>
        <button mat-raised-button color="warn" type="button" (click)="deleteTag(tag)" class="mat-list-item-content-right">Löschen</button>
      </span>
      <span matListItemLine></span>
    </mat-list-item>
  </mat-list>

  <button mat-button (click)="addTag()">
    <mat-icon>add_box</mat-icon>
    Tag hinzufügen
  </button>
</div>
